/**
 * @generated SignedSource<<15975f0e4ff32bc96abad4f7ad5be27c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletType"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "walletType",
        "variableName": "walletType"
      }
    ],
    "concreteType": "WalletType",
    "kind": "LinkedField",
    "name": "getTransactions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "TransDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "Debit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "Credit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "DebitCreditStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ClosingBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "NonPromotionalBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "Details",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "TransactionExpireDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "IsPromotionalWalletExpired",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetTransactionDetailsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetTransactionDetailsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "29d916181ed217c26772ec19c8e3fbbf",
    "id": null,
    "metadata": {},
    "name": "GetTransactionDetailsQuery",
    "operationKind": "query",
    "text": "query GetTransactionDetailsQuery(\n  $limit: Int\n  $walletType: WalletTypeEnum\n) {\n  getTransactions(limit: $limit, walletType: $walletType) {\n    TransDate\n    Debit\n    Credit\n    DebitCreditStatus\n    ClosingBalance\n    NonPromotionalBalance\n    Details\n    TransactionExpireDate\n    IsPromotionalWalletExpired\n  }\n}\n"
  }
};
})();

node.hash = "9a99562fbef6784ad3162564c4be2538";

module.exports = node;
